import React from "react";
import Card from "../../components/page/Card";
import LogosDataTable from "./Logos/LogosDataTable";
import useApi from "../../hooks/useApi";
import LogosApiClient from "../../api/logos";
import LogosModal from "./Logos/LogosModal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";

function Logos() {
  const [logos, setLogos] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [logoModal, setLogoModal] = React.useState(false);

  const { request: getLogos, data: logosResponse } = useApi(
    LogosApiClient.getLogos
  );
  const postLogosApi = useApi(LogosApiClient.postLogos);
  const deleteLogosApi = useApi(LogosApiClient.deleteLogos);

  //Busca logos ao renderizar tela
  React.useEffect(() => {
    getLogos();
  }, [getLogos]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (logosResponse) setLogos(logosResponse);
  }, [logosResponse]);

  const togLogoModal = () => {
    setValues({});
    setLogoModal(true);
  };

  const salvaLogo = async () => {
    const formData = new FormData();
    formData.append("arquivo", values?.arquivo);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postLogosApi.request(formData);
    if (!response) return;
    CommonSwal({
      icon: "success",
      title: "Logo salva com sucesso.",
    });
    setLogoModal(false);
    getLogos();
  };

  const apagaLogo = async (nome) => {
    const nomeTratado = nome.split(".");
    const response = await deleteLogosApi.request(
      nomeTratado[0],
      nomeTratado[1]
    );
    if (!response) return;
    setLogoModal(false);
    getLogos();
  };

  return (
    <>
      <Card>
        <LogosDataTable
          linhas={logos}
          togLogoModal={togLogoModal}
          apagaLogo={apagaLogo}
        />
      </Card>
      <LogosModal
        modalHook={{ logoModal, setLogoModal }}
        valuesHook={{ values, setValues }}
        salvaLogo={salvaLogo}
      />
    </>
  );
}

export default Logos;
